<template>
  <div class="collection">
    <div class="coll_top" :style="'background-image:url('+liveinfo.poster+')'">
      <div class="mask">
        <h1 class="coll_title">{{liveinfo.collection.title || '直播合集'}}</h1>
        <p class="coll_count">共{{liveinfo.collection.count}}场直播</p>
      </div>
    </div>
    <div class="coll_bottom">
      <div class="coll_label">合集</div>
      <p class="title_coll">{{liveinfo.title}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['liveinfo']
}
</script>

<style scoped>
.collection {
  margin-bottom: .45rem;
}
.coll_top{
  width: 100%;
  height: 4.23rem;
  margin-bottom: .25rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.mask {
  box-sizing: border-box;
  padding: 0 1.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.coll_title{
  width: 100%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: .36rem;
  color: #fff;
  font-weight: normal;
}
.coll_count{
  font-size: .26rem;
  color: #fff;
  margin-top: .4rem;
}
.coll_bottom {
  box-sizing: border-box;
  padding: 0 .3rem;
  display: flex;
  align-items: center;
}
.coll_label{
  width: .98rem;
  height: .4rem;
  margin-right: .2rem;
  background-color: #E7F1FC;
  color: #027AFF;
  font-size: .26rem;
  line-height: .4rem;
  text-align: center;
  border-radius: 5px;
}
.title_coll{
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: .32rem;
  color: #333;
}
</style>